const enrollmentMetricsMessages = {
  pageTitles: {
    title: 'Enrollment Metrics ',
    subtitle:
      'Demographics of members and the plan types in which they have elected.',
    subTitleMiddleString: ' to ',
    subTitleStartPeriod: 'January 2021',
    subTitleEndPeriod: 'December 2022.',
  },
  buttonText: {
    download: 'Download',
    queryData: 'Query Data',
  },
  cardText: {
    totalEligible: 'Total Eligible',
    employees: 'Employees',
    totalEnrolled: 'Total Enrolled',
    dependents: 'Dependents',
    totalCost: 'Total Cost',
    medical: 'Medical',
    rx: 'Rx',
    pmpm: 'PMPM',
    pepm: 'PEPM',
    medicalVsRx: 'Medical vs Rx Plan Paid',
  },
  memberEnrollmentAnalysisChartLegends: [
    {
      label: 'Current Year',
      color: '#919DD0',
    },
    {
      label: 'Previous Year',
      color: '#DADEEF',
    },
  ],
  enrollmentHealthCareChart: {
    TITLE: 'Enrollment by Subscription Type',
    SUBTITLE: 'This visual shows the distribution of subscription types',
    emptyText: 'We do not have enrollment details to display',
    ENROLLMENT: {
      TITLE: 'Enrollments',
      SUBTITLE: 'This visual shows the distribution of subscription types',
    },
  },
};

export default enrollmentMetricsMessages;
